import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'

import {
  selectCountrySelectState,
  selectTransactionTypeState,
} from '../../../../app-store/AccountSetupSlice'

import {LOCATION_FIELDS} from '../config/locationFields'

import {DynamicField} from './DynamicField'

import {
  FormGrid,
  FullWidth,
  LeftColumn,
  RightColumn,
} from '../AccountInfo.style'
import {buildFieldConfigMap} from '../config/locationFieldRules'
import {selectEffectiveRole} from '../../../../app-store/selector'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {useUserFeatures} from '../../../../context/user-features-context'

export function LocationForm({
  roles,
  account,
  values = {},
  errors = {},
  touched = {},
  onChange,
  onBlur,
  variant = 'form',
  size = 'md',
  disabled = false,
  disabledFields = [],
  country,
  isAddLocation = false,
  isChildLocation,
  hasStoredLocationName = false,
  hiddenFields = [],
}) {
  const selectedRoles = useSelector(selectEffectiveRole)
  const effectiveRoles = roles ?? selectedRoles

  const {frontendOverrideSst} = useFlags()
  const {Enable_Internal_Account_Checkbox} = useUserFeatures()

  const {states, selectedCountry: reduxCountry} = useSelector(
    selectCountrySelectState,
  )

  const {selectedTransactionType} = useSelector(selectTransactionTypeState)
  const selectedCountry = country || reduxCountry

  const effectiveIsChildLocation =
    isChildLocation !== undefined
      ? isChildLocation
      : account?.type === 'child' || isAddLocation

  const fieldConfigMap = useMemo(
    () =>
      buildFieldConfigMap({
        roles: effectiveRoles,
        account,
        values,
        selectedCountry,
        selectedTransactionType,
        states,
        isAddLocation,
        isChildLocation: effectiveIsChildLocation,
        hasStoredLocationName,
        frontendOverrideSst,
        enableInternalAccountCheckbox: Enable_Internal_Account_Checkbox,
      }),
    [
      effectiveRoles,
      account,
      values,
      selectedCountry,
      selectedTransactionType,
      states,
      isAddLocation,
      effectiveIsChildLocation,
      hasStoredLocationName,
      frontendOverrideSst,
      Enable_Internal_Account_Checkbox,
    ],
  )

  const resolvedFields = useMemo(() => {
    return LOCATION_FIELDS.map(field => ({
      ...field,
      ...(fieldConfigMap[field.key] || {}),
    }))
      .filter(field => field.visible !== false)
      .filter(field => !hiddenFields.includes(field.key))
  }, [fieldConfigMap, hiddenFields])

  return (
    <FormGrid>
      {resolvedFields.map(field => {
        const fieldElement = (
          <DynamicField
            key={field.key}
            field={field}
            value={values[field.key]}
            values={values}
            error={errors[field.key]}
            touched={touched[field.key]}
            disabled={
              disabled || field.disabled || disabledFields.includes(field.key)
            }
            variant={variant}
            size={size}
            onChange={onChange}
            onBlur={onBlur}
            country={selectedCountry}
          />
        )

        if (field.layout === 'full') {
          return <FullWidth key={field.key}>{fieldElement}</FullWidth>
        }

        if (field.layout === 'left') {
          return <LeftColumn key={field.key}>{fieldElement}</LeftColumn>
        }

        if (field.layout === 'right') {
          return <RightColumn key={field.key}>{fieldElement}</RightColumn>
        }

        return <React.Fragment key={field.key}>{fieldElement}</React.Fragment>
      })}
    </FormGrid>
  )
}

// import React, {useMemo, useEffect} from 'react'
// import {useSelector} from 'react-redux'

// import {
//   selectCountrySelectState,
//   selectTransactionTypeState,
// } from '../../../../app-store/AccountSetupSlice'

// import {LOCATION_FIELDS} from '../config/locationFields'

// import {DynamicField} from './DynamicField'

// import {FormGrid, FullWidth} from '../AccountInfo.style'
// import {buildFieldConfigMap} from '../config/locationFieldRules'
// import {selectUserRoles} from '../../../../app-store/selector'

// export function buildFieldProps({
//   field,
//   fieldConfig,
//   values,
//   errors,
//   touched,
//   disabled,
//   variant,
//   size,
//   onChange,
// }) {
//   return {
//     field,

//     value: values[field.key],

//     values,

//     error: errors[field.key],

//     touched: touched[field.key],

//     disabled: disabled || fieldConfig?.disabled,

//     variant,

//     size,

//     labelLeftIcon: fieldConfig?.labelLeftIcon,

//     options: fieldConfig?.options || [],

//     onChange,
//   }
// }

// export function LocationForm({
//   account,
//   values = {},
//   errors = {},
//   touched = {},
//   onChange,
//   variant = 'form',
//   size = 'md',
//   disabled = false,
// }) {
//   const {actualRole} = useSelector(selectUserRoles)

//   const {states, selectedCountry} = useSelector(selectCountrySelectState)

//   const {selectedTransactionType} = useSelector(selectTransactionTypeState)

//   const fieldConfigMap = useMemo(
//     () =>
//       buildFieldConfigMap({
//         roles: actualRole,
//         account,
//         values,
//         selectedCountry,
//         selectedTransactionType,
//         states,
//       }),
//     [account, values, selectedCountry, selectedTransactionType, states],
//   )

//   /* ─────────────────────────────────────────
//    * Apply defaults
//    * ───────────────────────────────────────── */

//   useEffect(() => {
//     LOCATION_FIELDS.forEach(field => {
//       const config = fieldConfigMap[field.key]

//       if (config?.defaultValue !== undefined && !values[field.key]) {
//         onChange(field.key, config.defaultValue)
//       }
//     })
//   }, [fieldConfigMap, values, onChange])

//   /* ─────────────────────────────────────────
//    * Visible fields
//    * ───────────────────────────────────────── */

//   const visibleFields = useMemo(() => {
//     return LOCATION_FIELDS.filter(field => {
//       const config = fieldConfigMap[field.key]

//       if (config?.visible === false) {
//         return false
//       }

//       return true
//     })
//   }, [fieldConfigMap])

//   return (
//     <FormGrid>
//       {visibleFields.map(field => {
//         const fieldProps = buildFieldProps({
//           field,
//           fieldConfig: fieldConfigMap[field.key],
//           values,
//           errors,
//           touched,
//           disabled,
//           variant,
//           size,
//           onChange,
//         })

//         const fieldElement = (
//           <DynamicField key={field.key} field={field} {...fieldProps} />
//         )

//         if (field.layout === 'full') {
//           return <FullWidth key={field.key}>{fieldElement}</FullWidth>
//         }

//         return <React.Fragment key={field.key}>{fieldElement}</React.Fragment>
//       })}
//     </FormGrid>
//   )
// }
